import { render, staticRenderFns } from "./TemplateSections.vue?vue&type=template&id=1de963c4&scoped=true"
import script from "./TemplateSections.vue?vue&type=script&lang=js"
export * from "./TemplateSections.vue?vue&type=script&lang=js"
import style0 from "./TemplateSections.vue?vue&type=style&index=0&id=1de963c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de963c4",
  null
  
)

export default component.exports